import React from 'react';
import { Badge, Box, ButtonBase, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CampaignIcon from '@mui/icons-material/Campaign';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { MESSENGER } from './messengerTheme';

export type MessengerTab = 'home' | 'messages' | 'help' | 'news';

const TABS: Array<{ id: MessengerTab; label: string; icon: React.ElementType; activeIcon: React.ElementType }> = [
  { id: 'home', label: 'Início', icon: HomeOutlinedIcon, activeIcon: HomeIcon },
  { id: 'messages', label: 'Mensagens', icon: ChatBubbleOutlineIcon, activeIcon: ChatBubbleIcon },
  { id: 'help', label: 'Ajuda', icon: HelpOutlineIcon, activeIcon: HelpIcon },
  { id: 'news', label: 'Novidades', icon: CampaignOutlinedIcon, activeIcon: CampaignIcon },
];

interface MessengerBottomNavProps {
  active: MessengerTab;
  onChange: (tab: MessengerTab) => void;
  unreadMessages: number;
}

const MessengerBottomNav: React.FC<MessengerBottomNavProps> = ({ active, onChange, unreadMessages }) => (
  <Box
    component="nav"
    aria-label="Seções da Central de suporte"
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      borderTop: `1px solid ${MESSENGER.border}`,
      bgcolor: MESSENGER.surface,
      flexShrink: 0,
      pb: 'env(safe-area-inset-bottom, 0px)',
    }}
  >
    {TABS.map((tab) => {
      const isActive = tab.id === active;
      const Icon = isActive ? tab.activeIcon : tab.icon;
      return (
        <ButtonBase
          key={tab.id}
          onClick={() => onChange(tab.id)}
          aria-current={isActive ? 'page' : undefined}
          sx={{
            flexDirection: 'column',
            gap: 0.4,
            py: 1.25,
            color: isActive ? MESSENGER.navy : MESSENGER.slate,
            '&:hover': { color: MESSENGER.navy },
          }}
        >
          <Badge color="error" badgeContent={tab.id === 'messages' ? unreadMessages : 0} invisible={tab.id !== 'messages' || !unreadMessages}>
            <Icon sx={{ fontSize: 24 }} />
          </Badge>
          <Typography sx={{ fontSize: '0.78rem', fontWeight: isActive ? 700 : 500, color: 'inherit' }}>{tab.label}</Typography>
        </ButtonBase>
      );
    })}
  </Box>
);

export default MessengerBottomNav;
